module.exports = __webpack_public_path__ + "static/media/Logo__EA.32613238.svg";